import React from "react";
import AgentProgressBar from "./AgentProgressBar";
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import useStyles from "./styles";

const Toggle = () => {
	const [show, toggleShow] = React.useState(true);
	var classes = useStyles();
	return (
		<div>
			<button className={classes.Button} onClick={() => toggleShow(!show)}>
				Today's Shift: {show ? <ExpandLessIcon /> : <ExpandMoreIcon />}
			</button>
			{show && (
				<div>
					<AgentProgressBar />
				</div>
			)}
		</div>
	);
};
export default Toggle;
